import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { CustomerSitesReadDTO, CustomerSitesCreateDTO } from '../generated/api-client';

export const useCustomerSites = () => {
  return useQuery<CustomerSitesReadDTO[]>('customerSites', () => apiClient.list_items_customer_sites__get());
};

export const useCustomerSitesById = (id: string) => {
  return useQuery<CustomerSitesReadDTO>(
    ['customerSites', id],
    () => apiClient.get_item_customer_sites__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useCustomerSitesByCustomerId = (customerId: string) => {
  return useQuery<CustomerSitesReadDTO[]>(
    ['customerSites', 'byCustomerId', customerId],
    () => apiClient.search_by_customer_id_customer_sites_search_by_customer_id__customer_id__get(customerId),
    {
      enabled: !!customerId,
    }
  );
};

export const useCreateCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<CustomerSitesReadDTO, Error, CustomerSitesCreateDTO>(
    (data) => apiClient.create_item_customer_sites__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customerSites');
      },
    }
  );
};

export const useUpdateCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<CustomerSitesReadDTO, Error, { id: string; data: CustomerSitesCreateDTO }>(
    ({ id, data }) => apiClient.update_item_customer_sites__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customerSites');
      },
    }
  );
};

export const useDeleteCustomerSites = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_customer_sites__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customerSites');
      },
    }
  );
};

